import { DiseaseCategoryType, QualifiedFeature } from "fe-common/graphql";
import { FeatureTerm, featureToTerms } from "fe-common/logic";
import { isPopulationFeature, Relations } from "shared";
import { DataInputPanel } from "../../dataInputTypes";
import { Suggestion } from "../hooks/useSuggestions";

interface SuggestionsPanelInterface {
  panel: DataInputPanel;
  suggestions: Suggestion[];
}

interface BuildLabSuggestionsInterface {
  (
    suggestions: Suggestion[],
    category: DiseaseCategoryType,
  ): SuggestionsPanelInterface[];
}

export class PanelsUtil {
  static featureToPanelText(qf: QualifiedFeature) {
    const terms = featureToTerms(qf);
    // use only the main feature name to keep things short
    return PanelsUtil.mainTerm(terms?.[0]);
  }
  static mainTerm(t: FeatureTerm) {
    if (!t) return null;
    const { feature, value } = t;
    const featureStr = feature?.name || (feature as any)?.alias || "";
    const valueStr = value?.value?.name;

    if (value?.relation?.id === Relations.EXPOSURE_TO) {
      return `${valueStr}`;
    } else if (value?.relation?.id === Relations.FAMILY_HISTORY) {
      return `${valueStr}`;
    } else if (value?.relation?.id === Relations.PROCEDURE_FINDING) {
      return `${valueStr}`;
    } else if (feature && isPopulationFeature(feature)) {
      return `${valueStr}`;
    } else return `${featureStr}`;
  }

  static addEllipsis(name: string, maxChars: number) {
    return name.length > maxChars ? name.substring(0, maxChars) + "..." : name;
  }

  static createPanel(id: string, title: string, findings: QualifiedFeature[]) {
    return {
      id: id,
      title: title,
      findings: findings,
    } as DataInputPanel;
  }
}

export const buildLabSuggestionsPanels: BuildLabSuggestionsInterface = (
  suggestions,
  categoryType,
) => {
  const labsSuggestions = suggestions.filter(
    (s) => s.category === categoryType,
  );

  let labsPanelsList = [];

  let noPanelSuggestions = [];

  labsSuggestions.forEach((suggestion) => {
    const panel =
      suggestion.panelIds.length > 0 ? suggestion.panelIds[0] : null;

    const panelExists = labsPanelsList.find(
      (lab) => lab.panel && panel && lab.panel.id === panel.id,
    );
    if (!panel || !panelExists) {
      const panelSuggestions = panel
        ? suggestions.filter(
            (s) =>
              (panel
                ? s.panelIds.some((p) => p.id === panel.id)
                : s.panelIds.length === 0) && s.category === categoryType,
          )
        : [suggestion];

      if (panel) {
        labsPanelsList.push({
          panel: panel,
          suggestions: panelSuggestions,
        });
      } else {
        noPanelSuggestions = [...noPanelSuggestions, ...panelSuggestions];
      }
    }
  });

  noPanelSuggestions.forEach((suggestion: Suggestion) => {
    labsPanelsList.push({
      panel: null,
      suggestions: [suggestion],
    });
  });

  return labsPanelsList;
};
